import styled from 'styled-components'

export const Container = styled.div`
  .ant-card-body {
    margin-bottom: -15px;
  }

  .ant-form-item-control:first-child:not([class^='ant-col-']):not([class*=' ant-col-']) {
    width: 90%;
  }

  .ant-drawer-header {
    padding: 0 !important;
  }

  .ant-upload,
  .ant-upload-list-item,
  .ant-upload-list-item-done {
    width: 200px !important;
    height: 200px !important;
  }
`
export const BodyDrawer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .campo__dois__inputs {
    display: flex;
    gap: 10px;
  }

  .header {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    background-color: rgb(224, 224, 224);
  }

  label {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-color);
    display: inline-flex;
    gap: 5px;
  }
`

export const BodyDados = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .foto-profile {
    width: 23%;
    display: flex;
    justify-content: center !important;
  
    /* Estilização do contêiner de upload */
    .ant-upload.ant-upload-select-picture-card,
    .ant-upload-list-picture-card-container {
      width: 200px !important;
      height: 200px !important;
      display: flex;
    }

    /* Estilização do item de upload */
    .ant-upload-list-item {
      width: 200px !important;
      height: 200px !important;
    }

    /* Garantir que a imagem se ajuste ao contêiner */
    .ant-upload-list-item-thumbnail {
      width: 100%;
      height: 100%;
    }

    .ant-upload-list-item-thumbnail img {
      object-fit: cover; /* Mantém a proporção da imagem, cobrindo todo o espaço */
      width: 100%;
      height: 100%;
    }

    ant-form-item-control:first-child:not([class^='ant-col-']):not([class*=' ant-col-']) {
      width: 100%;
    }

    .ant-upload.ant-upload-select-picture-card,
    .ant-upload-list-picture-card-container {
      width: 100%;
      max-width: 100%;
      min-height: 200px;
    }

    .ant-upload {
      width: 200px !important;
      height: 200px !important;
    }

    .ant-upload-list-item-done {
      width: 207px !important;
      height: 200px !important;
    }
  }

  .foto-upload {
    width: 100% !important;
    height: 200px;
    display: flex !important;
    flex-direction: column !important;
  }
`

export const FormDados = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 35px;

  .radio-sexo {
    width: 50%;
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  
  .radio-group{
    margin-top: 5px;
  }

  .radio-group .ant-radio-button-wrapper-checked {
    background-color: #5da57d;
    border-color: #5da57d;
    color: white; /* Cor do texto quando selecionado */
  }
  /* Estilo quando o radio está checked e em hover */
  .radio-group .ant-radio-button-wrapper-checked:hover {
    background-color: #5da57d; /* Verde no hover quando está checked */
    border-color: #5da57d;
    color: white; /* Texto branco quando hover e checked */
  }

  /* Estilo quando o radio não está checked e em hover */
  .radio-group .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-checked):hover {
    background-color: transparent; /* Mantém transparente no hover quando não está checked */
    border-color: #d9d9d9;
    color: #5da57d; /* Texto verde no hover quando não está checked */
  }

  .data-nascimento {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`
